import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import colors from "../../constants/colors";
import { MOBILE } from "../../constants/breakpoints";
import { Container, NFTImg, RowSpan } from "./style";
import { BodyRegular } from "../../shared/typography";

const NftComp = ({
  icon,
  label,
  onClick,
}: {
  icon: string;
  label: string;
  onClick: any;
}) => {
  return (
    <Container
      onClick={onClick}
    >
      <NFTImg
        src={icon?.includes('ipfs://') ? `https://cf-ipfs.com/ipfs/${icon?.split('://')[1]}` : icon}
        alt="token-image"
      />
      <RowSpan>
        <BodyRegular className="lableText" color='#191414'>
          {label}
        </BodyRegular>
      </RowSpan>
      {/* <div className="burnButton">
        Burn Token
      </div> */}
    </Container>
  );
};

export default NftComp;
